export class SubscriptionPaymentEntity {
  id: number

  subscriptionEntityId: number

  mercadoPagoPaymentId: string

  amount: number

  status: string

  statusDetail?: string

  paidAt?: Date

  createdAt: Date

  constructor(data: Partial<SubscriptionPaymentEntity>) {
    this.id = data.id ?? 0

    this.subscriptionEntityId = data.subscriptionEntityId ?? 0

    this.mercadoPagoPaymentId = data.mercadoPagoPaymentId ?? ""

    this.amount = data.amount ?? 0

    this.status = data.status ?? ""

    this.statusDetail = data.statusDetail

    this.paidAt = data.paidAt ? new Date(data.paidAt) : undefined

    this.createdAt = data.createdAt ? new Date(data.createdAt) : new Date()
  }

  isApproved() {
    return this.status === "approved"
  }

  isRejected() {
    return this.status === "rejected"
  }

  isInProcess() {
    return this.status === "in_process"
  }
}
